module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_16.e35e0e80.jpg";